import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { HttpError } from 'src/app/shared/models/http-error.model';
import { User } from 'src/app/shared/models/user.model';
import { RecaptchaComponent } from 'ng-recaptcha';
import { UserService } from 'src/app/shared/service/user.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
  isOtp = false;
  error: any = {};
  signInLoading = false;
  user: User = new User();
  errorMessage: string | undefined;
  showPassword = false;
  showConfirmPassword = false;
  @ViewChild('captchaRef') recaptcha!: RecaptchaComponent;
  rememberMe = false;
  twoFactorCode!: string;
  twoFactorLoading = false;
  page!: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private location: Location
  ) {
  }

  getInputType(): string {
    if (this.showPassword) {
      return 'text';
    }
    return 'password';
  }

  toggleShowPassword(type: string): void {
    if (type === 'password') {
      this.showPassword = !this.showPassword;
    } else {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }

  signIn(): void {
    this.errorMessage = undefined;
    this.error = {};
    if (this.page === 'two-factor-authentication') {
      this.twoFactorLoading = true;
    } else {
      this.signInLoading = true;
    }

    this.authenticationService
      .signIn(this.user.email, this.user.password, this.twoFactorCode)
      .subscribe(
        (response) => {
          if (response.status === 'OK') {
            this.userService.userStream.next(new User(response.data));
            this.authenticationService.setToken(response.token, this.rememberMe);
            this.authenticationService.userRole = response.data.role;
            this.router.navigateByUrl('/dashboard');
          } else if (response.status === 'GOOGLE_AUTH') {
            this.router.navigateByUrl('/two-factor-authentication', {
              state: {
                email: this.user.email,
                password: this.user.password,
                rememberMe: this.rememberMe
              }
            });
          }
        },
        (response: HttpError) => {
          if (response.status === 422) {
            this.error = response.validationError;
          } else {
            this.errorMessage = response.error;
          }
          if (this.page === 'two-factor-authentication') {
            this.twoFactorLoading = false;
          } else {
            this.signInLoading = false;
          }
        }
      );
  }

  ngOnInit(): void {
    this.page = this.route.snapshot.data?.action;
    if (this.page === 'two-factor-authentication') {
      const routeState: any = this.location.getState();
      if (!routeState.email) {
        this.router.navigateByUrl('/sign-in');
        return;
      }
      this.user = new User();
      this.user.email = routeState.email;
      this.user.password = routeState.password;
    }
  }
}
